<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useDisciplineDetailMenu } from '../model/discipline-detail-menu.hook'

defineOptions({
  name: 'DisciplineDetailMenu',
})

const {
  config,
} = useDisciplineDetailMenu()
</script>

<template>
  <NavigationLinkTabs
    :config="config"
  />
</template>